<script setup>
import { reactive, ref, computed, onMounted } from "vue"
import { useToast } from "vue-toastification"
import { useRouter } from "vue-router"

import Multiselect from "@vueform/multiselect"
import "@vueform/multiselect/themes/default.css"

import CKEditor from "@ckeditor/ckeditor5-vue"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import "@ckeditor/ckeditor5-build-classic/build/translations/fa"

import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"

import store from "../../state/store"

// Get toast interface
const toast = useToast()

const title = "افزودن مناسبت"
const items = ref([
  {
    text: "داشبورد",
    href: "/",
  },
  {
    text: "افزودن مناسبت",
    active: true,
  },
])

const occasion = reactive({
  selectedTag: "",
  selectedOccasionType: "",
  title: "",
  description: "",
  full_description: "",
  buy_text: "",
  is_public: "",
  occasion_date: "",
  occasion_date_type: "",
  reminder_text_1: "",
  reminder_text_2: "",
  reminder_text_3: "",
  reminder_text_4: "",
  reminder_text_5: "",
  reminder_text_6: "",
  occasion_image: "",
})

const errors = ref({})
const router = useRouter()
const loading = ref(false)

const allOccasionTypes = computed(() =>
  store.state.allOccasionTypes.data.map((item) => {
    return {
      value: item.id,
      label: item.title,
    }
  })
)

const allTags = computed(() =>
  store.state.allTags.data.map((item) => {
    return {
      value: item.id,
      label: item.title,
    }
  })
)

/**
 *! start file
 */

const onFileChange = (event) => {
  occasion.occasion_image = event.target.files[0]
}

/**
 *! end file
 */

/**
 *! start editor
 */

const editorConfig = {
  language: "fa",
  toolbar: [
    "undo",
    "redo",
    "|",
    "heading",
    "|",
    "bold",
    "italic",
    "-", // break point
    "|",
    "alignment",
    "link",
    "|",
    "bulletedList",
    "numberedList",
  ],
  ckfinder: {
    options: {
      language: "fa",
    },
  },
}

const editor = ClassicEditor
const ckeditor = CKEditor.component

/**
 *! end editor
 */

onMounted(() => {
  store.dispatch("getAllTags")
  store.dispatch("getAllOccasionTypes")
})

const onSubmit = () => {
  loading.value = true
  store
    .dispatch("createOccasion", {
      occasion,
    })
    .then((response) => {
      loading.value = false
      if (response.status === 201) {
        router.push({ name: "occasion.occasions" })
        toast.success(" مناسبت با موفقیت افزوده شد!", {
          timeout: 4000,
        })
      }
    })
    .catch((err) => {
      loading.value = false
      errors.value = err.response.data.errors
    })
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-overlay
      variant="white"
      opacity="0.75"
      blur="2px"
      :show="loading"
      spinner-variant="success"
      rounded="sm"
    >
      <b-row>
        <b-col lg="8">
          <form @submit.prevent="onSubmit" enctype="multipart/form-data">
            <b-card no-body>
              <b-card-body>
                <div class="mb-3">
                  <label class="form-label" for="occasion_title"
                    >عنوان مناسبت</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="occasion_title"
                    placeholder="عنوان مناسبت را وارد کنید"
                    v-model="occasion.title"
                  />
                  <div v-if="errors">
                    <div class="invalid-feedback" v-if="errors.title">
                      <span>{{ errors.title[0] }}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <label class="form-label">توضیحات مناسبت</label>
                  <ckeditor
                    v-model="occasion.full_description"
                    :editor="editor"
                    :config="editorConfig"
                  ></ckeditor>
                </div>
              </b-card-body>
            </b-card>

            <b-card no-body>
              <b-card-header>
                <h5 class="card-title mb-0">تاریخ مناسبت</h5>
              </b-card-header>
              <b-card-body>
                <b-row>
                  <b-col sm="6">
                    <div class="mb-3">
                      <label class="form-label" for="occasion_date"
                        >تاریخ</label
                      >
                      <div class="input-group mb-3">
                        <custom-date-picker
                          v-model="occasion.occasion_date"
                          id="occasion_date"
                        ></custom-date-picker>
                      </div>
                      <div v-if="errors">
                        <div
                          class="invalid-feedback"
                          v-if="errors.occasion_date"
                        >
                          <span>{{ errors.occasion_date[0] }}</span>
                        </div>
                      </div>
                    </div>
                  </b-col>

                  <b-col sm="6">
                    <div class="mb-3">
                      <label class="form-label" for="occasion_date_type"
                        >نوع تقویم</label
                      >
                      <div class="input-group mb-3">
                        <Multiselect
                          class="form-control"
                          id="occasion_date_type"
                          v-model="occasion.occasion_date_type"
                          :close-on-select="true"
                          :searchable="false"
                          :create-option="true"
                          :options="[
                            { value: '1', label: 'شمسی' },
                            { value: '2', label: 'قمری' },
                            { value: '3', label: 'میلادی' },
                          ]"
                          placeholder="شمسی، قمری یا میلادی"
                        />
                      </div>
                      <div v-if="errors">
                        <div
                          class="invalid-feedback"
                          v-if="errors.occasion_date_type"
                        >
                          <span>{{ errors.occasion_date_type[0] }}</span>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>

            <b-card no-body>
              <b-card-header>
                <h5 class="card-title mb-0">تصویر مناسبت</h5>
              </b-card-header>
              <b-card-body>
                <div class="mb-4">
                  <p class="text-muted">تصویر اصلی مناسبت را اضافه کنید.</p>
                  <input
                    class="form-control"
                    id="occasion-image-input"
                    type="file"
                    accept="image/png, image/gif, image/jpeg"
                    @change="onFileChange"
                  />
                  <div v-if="errors">
                    <div class="invalid-feedback" v-if="errors.occasion_image">
                      <span>{{ errors.occasion_image[0] }}</span>
                    </div>
                  </div>
                </div>
              </b-card-body>
            </b-card>

            <b-card no-body>
              <b-card-header>
                <ul
                  class="nav nav-tabs nav-border-top nav-border-top-success card-header-tabs border-bottom-0"
                  role="tablist"
                >
                  <li class="nav-item">
                    <b-link
                      class="nav-link active"
                      data-bs-toggle="tab"
                      href="#addoccasion-reminder-text1"
                      role="tab"
                    >
                      اعلان اول
                    </b-link>
                  </li>
                  <li class="nav-item">
                    <b-link
                      class="nav-link"
                      data-bs-toggle="tab"
                      href="#addoccasion-reminder-text2"
                      role="tab"
                    >
                      اعلان دوم
                    </b-link>
                  </li>
                  <li class="nav-item">
                    <b-link
                      class="nav-link"
                      data-bs-toggle="tab"
                      href="#addoccasion-reminder-text3"
                      role="tab"
                    >
                      اعلان سوم
                    </b-link>
                  </li>

                  <li class="nav-item">
                    <b-link
                      class="nav-link"
                      data-bs-toggle="tab"
                      href="#addoccasion-reminder-text4"
                      role="tab"
                    >
                      اعلان چهارم
                    </b-link>
                  </li>

                  <li class="nav-item">
                    <b-link
                      class="nav-link"
                      data-bs-toggle="tab"
                      href="#addoccasion-reminder-text5"
                      role="tab"
                    >
                      اعلان پنجم
                    </b-link>
                  </li>

                  <li class="nav-item">
                    <b-link
                      class="nav-link"
                      data-bs-toggle="tab"
                      href="#addoccasion-reminder-text6"
                      role="tab"
                    >
                      اعلان ششم
                    </b-link>
                  </li>
                </ul>
              </b-card-header>
              <b-card-body>
                <div class="tab-content mt-2">
                  <div
                    class="tab-pane active"
                    id="addoccasion-reminder-text1"
                    role="tabpanel"
                  >
                    <div>
                      <label class="form-label" for="reminder_text_1"
                        >دو هفته قبل از یک مناسبت ثبت شده - ساعت ۱۰:۰۰</label
                      >
                      <textarea
                        class="form-control"
                        id="reminder_text_1"
                        placeholder=" متن مورد نظر برای ارسال را وارد کنید"
                        rows="3"
                        v-model="occasion.reminder_text_1"
                      ></textarea>
                    </div>
                  </div>

                  <div
                    class="tab-pane"
                    id="addoccasion-reminder-text2"
                    role="tabpanel"
                  >
                    <div>
                      <label class="form-label" for="reminder_text_2"
                        >۵ روز قبل از یک مناسبت ثبت شده - ساعت ۱۰:۰۰</label
                      >
                      <textarea
                        class="form-control"
                        id="reminder_text_2"
                        placeholder=" متن مورد نظر برای ارسال را وارد کنید"
                        rows="3"
                        v-model="occasion.reminder_text_2"
                      ></textarea>
                    </div>
                  </div>

                  <div
                    class="tab-pane"
                    id="addoccasion-reminder-text3"
                    role="tabpanel"
                  >
                    <div>
                      <label class="form-label" for="reminder_text_3"
                        >ساعت ۰۰:۰۰ همان روز یک مناسبت ثبت شده</label
                      >
                      <textarea
                        class="form-control"
                        id="reminder_text_3"
                        placeholder=" متن مورد نظر برای ارسال را وارد کنید"
                        rows="3"
                        v-model="occasion.reminder_text_3"
                      ></textarea>
                    </div>
                  </div>

                  <div
                    class="tab-pane"
                    id="addoccasion-reminder-text4"
                    role="tabpanel"
                  >
                    <div>
                      <label class="form-label" for="reminder_text_4"
                        >ساعت ۰۸:۰۰ همان روز یک مناسبت ثبت شده</label
                      >
                      <textarea
                        class="form-control"
                        id="reminder_text_4"
                        placeholder=" متن مورد نظر برای ارسال را وارد کنید"
                        rows="3"
                        v-model="occasion.reminder_text_4"
                      ></textarea>
                    </div>
                  </div>

                  <div
                    class="tab-pane"
                    id="addoccasion-reminder-text5"
                    role="tabpanel"
                  >
                    <div>
                      <label class="form-label" for="reminder_text_5"
                        >یک روز قبل وقتی این مناسبت برای آن شخص ثبت نشده است -
                        ساعت ۱۷:۰۰</label
                      >
                      <textarea
                        class="form-control"
                        id="reminder_text_5"
                        placeholder=" متن مورد نظر برای ارسال را وارد کنید"
                        rows="3"
                        v-model="occasion.reminder_text_5"
                      ></textarea>
                    </div>
                  </div>

                  <div
                    class="tab-pane"
                    id="addoccasion-reminder-text6"
                    role="tabpanel"
                  >
                    <div>
                      <label class="form-label" for="reminder_text_6"
                        >همان روز وقتی این مناسبت برای آن شخص ثبت نشده است -
                        ساعت ۰۹:۰۰</label
                      >
                      <textarea
                        class="form-control"
                        id="reminder_text_6"
                        placeholder=" متن مورد نظر برای ارسال را وارد کنید"
                        rows="3"
                        v-model="occasion.reminder_text_6"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </b-card-body>
            </b-card>
            <div class="text-end mb-3">
              <b-button type="submit" variant="success" class="w-sm"
                >افزودن</b-button
              >
            </div>
          </form>
        </b-col>

        <b-col lg="4">
          <b-card no-body>
            <b-card-header>
              <h5 class="card-title mb-0">متن دکمه خرید</h5>
            </b-card-header>
            <b-card-body>
              <label class="form-label" for="buy-text"
                >متن دکمه خرید برای این مناسبت</label
              >
              <input
                type="text"
                class="form-control"
                id="buy-text"
                placeholder="متن دکمه خرید را وارد کنید"
                v-model="occasion.buy_text"
              />
              <div v-if="errors">
                <div class="invalid-feedback" v-if="errors.buy_text">
                  <span>{{ errors.buy_text[0] }}</span>
                </div>
              </div>
            </b-card-body>
          </b-card>

          <b-card no-body>
            <b-card-header>
              <h5 class="card-title mb-0">توضیحات کوتاه</h5>
            </b-card-header>
            <b-card-body>
              <p class="text-muted mb-2">توضیحات کوتاه برای این مناسبت</p>
              <textarea
                class="form-control"
                placeholder="توضیحات کوتاه برای این مناسبت را وارد کنید"
                rows="3"
                v-model="occasion.description"
              ></textarea>
            </b-card-body>
          </b-card>

          <b-card no-body>
            <b-card-header>
              <h5 class="card-title mb-0">نوع مناسبت</h5>
            </b-card-header>
            <b-card-body>
              <p class="text-muted mb-2">یک نوع انتخاب کنید</p>

              <Multiselect
                class="form-control"
                v-model="occasion.selectedOccasionType"
                :searchable="false"
                :options="allOccasionTypes"
                placeholder="یک نوع مناسبت انتخاب کنید"
              />
              <div v-if="errors">
                <div class="invalid-feedback" v-if="errors.occasion_type_id">
                  <span>{{ errors.occasion_type_id[0] }}</span>
                </div>
              </div>
            </b-card-body>
          </b-card>

          <b-card no-body>
            <b-card-header>
              <h5 class="card-title mb-0">برچسب های محصولات</h5>
            </b-card-header>
            <b-card-body>
              <p class="text-muted mb-2">یک برچسب انتخاب کنید</p>

              <Multiselect
                class="form-control"
                v-model="occasion.selectedTag"
                :searchable="false"
                :options="allTags"
                placeholder="یک برچسب انتخاب کنید"
              />
              <div v-if="errors">
                <div class="invalid-feedback" v-if="errors.tag_id">
                  <span>{{ errors.tag_id[0] }}</span>
                </div>
              </div>
            </b-card-body>
          </b-card>

          <b-card no-body>
            <b-card-header>
              <h5 class="card-title mb-0">عمومی/خصوصی</h5>
            </b-card-header>
            <b-card-body>
              <div class="mb-3">
                <label for="is_public" class="form-label">وضعیت</label>
                <Multiselect
                  class="form-control"
                  v-model="occasion.is_public"
                  :close-on-select="true"
                  :searchable="true"
                  :create-option="true"
                  :options="[
                    { value: '0', label: 'خصوصی' },
                    { value: '1', label: 'عمومی' },
                  ]"
                  placeholder="عمومی یا خصوصی"
                />
                <div v-if="errors">
                  <div class="invalid-feedback" v-if="errors.is_public">
                    <span>{{ errors.is_public[0] }}</span>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-overlay>
  </Layout>
</template>

<style scoped>
.vpd-main {
  width: 100% !important;
}
</style>
